import React, { useState, useEffect } from 'react';
import s from './CandidateStatus.scss';
import makeRequest from '../../../utils/makeRequest';
import { ELECTION_STATUS_MAPPING, TOI_HTE_DOMAIN } from '../../../constants';
import { arrayToHashMap } from '../../../components/ElectionV2/utils/loksabhaComputation';

const CandidateStatus = ({ candidateList }) => {
  // TODO: Election Widget
  const LIVE_STATUS_API = `${TOI_HTE_DOMAIN}/electiondhfeed/lok-sabha-candidates-live-lang${
    __PROD__ ? '' : '-qa'
  }/2024.json`;
  // eslint-disable-next-line no-unused-vars
  const [statusData, setStatusData] = useState({});
  const fetchData = url => {
    makeRequest.get(url, {}, 'skipfeedengine').then(response => {
      if (response) {
        setStatusData(arrayToHashMap(response?.data, 'c_id'));
      }
    });
  };
  useEffect(() => {
    fetchData(LIVE_STATUS_API);
    setInterval(() => {
      fetchData(LIVE_STATUS_API);
    }, 30 * 1000);
  }, []);
  return (
    <div className={s.candidateResultStatusWrap}>
      {candidateList &&
        Array.isArray(candidateList) &&
        candidateList.length > 0 &&
        candidateList.map(candidate => (
          <>
            <span>{candidate?.cns_name}</span>
            <span className={s.pipe} />
            <span>{candidate?.sn}</span>
            <span className={s.pipe} />
            <span>{candidate?.pn}</span>
            <span className={s.pipe} />
            <div
              className={`${s.statusCap} ${
                s[ELECTION_STATUS_MAPPING[statusData?.[candidate?.c_id]?.cs]]
              }`}
            >
              {ELECTION_STATUS_MAPPING[statusData?.[candidate?.c_id]?.cs] ||
                'Awaited'}
            </div>
          </>
        ))}
    </div>
  );
};

export default CandidateStatus;
